import { render, staticRenderFns } from "./chatSimpleList.vue?vue&type=template&id=7a9e200c&scoped=true"
import script from "./chatSimpleList.vue?vue&type=script&lang=js"
export * from "./chatSimpleList.vue?vue&type=script&lang=js"
import style0 from "./chatSimpleList.vue?vue&type=style&index=0&id=7a9e200c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9e200c",
  null
  
)

export default component.exports